import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  title: {
    padding: theme.spacing(2),
    color: 'rgba(0, 0, 0, 0.7)',
    lineHeight: '1.25em',
    textAlign: 'center',
  },
  item: {
    height: '100%',
    position: 'relative',
  },
  itemControls: {
    position: 'absolute',
    top: '0',
    right: '0',
    zIndex: '2',
    background: 'rgba(0, 0, 0, 0.3)',
    '& *': {
      color: `${'#FFF'} !important`,
    },
  },
}))
